import './webfunny-monitor'
import WfEvent from './webfunny-event.js'
import { envConfig } from './config/env.js'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import pinia from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import './styles/main.css'

// 初始化应用信息，越早执行越好
WfEvent.initEvent({
  webfunnyDomain: envConfig.webfunnyDomain,
  webfunnyAssetsDomain: envConfig.webfunnyAssetsDomain,
  projectId: envConfig.eventId, // 埋点SDK ID，根据环境动态生成
  env: envConfig.env,
  projectVersion: envConfig.projectVersion,
  initPoints: envConfig.envInitPoints,
  setting: {
    heartBeat: {
      // 心跳配置
      enable: true, // 心跳开关；true：开，false：关
      gap: 15 // 心跳间隔，单位：秒；数值枚举：5、15、30、60，其他数值无效，会默认为15
    }
  }
})

const app = createApp(App)

app.use(pinia)
app.use(router)
app.use(ElementPlus)

app.mount('#app')
